import { type FC } from 'react';
import { Building2 } from 'lucide-react';

import { cn } from '@/shared/libs';

export interface ProviderNameProps {
  alias?: string;
  className?: string;
  name: string;
}

export const ProviderName: FC<ProviderNameProps> = ({
  alias,
  className,
  name,
}) => (
  <div className={cn('flex min-w-0 items-center gap-2.5', className)}>
    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-muted">
      <Building2 className="h-4 w-4 text-muted-foreground" />
    </div>
    <div className="min-w-0">
      <p className="truncate font-medium text-foreground">{name}</p>
      {!!alias && (
        <p className="mt-0.5 truncate font-mono text-[11px] text-muted-foreground">
          {alias}
        </p>
      )}
    </div>
  </div>
);

ProviderName.displayName = 'ProviderName';
